<script>
  export default {
    props: {
      item: Object,
      relatorio: {
        type: Boolean,
        required: false,
        default: false
      },
      solicitacao: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao()
      }
    },
    computed: {
        retornaSimboloMoeda() {
          if (!this.solicitacao.idMoeda)
            return '';

          if (this.solicitacao.importacaoMoeda.simbolo)
            return '(' + this.solicitacao.importacaoMoeda.simbolo + ')';

          return '';
        }
    },
    methods: {
      classeOpcoes(valor) {
        return valor ? 'fa-check-square-o' : 'fa-square-o';
      },
      valorTotal(item) {
        const valorEstimado = this.$options.filters.formatarNumero(item.valorEstimado, true);
        const quantidade = this.$options.filters.formatarNumero(item.quantidade, true);

        return (quantidade * valorEstimado);
      },
      valorTotalReal(item) {
        const valorEstimado = this.$options.filters.formatarNumero(item.valorEstimado, true);
        const quantidade = this.$options.filters.formatarNumero(item.quantidade, true);
        let cotacao = this.$options.filters.formatarNumero(this.solicitacao.cotacaoEstimada, true, true,5); 

        if (!cotacao)
            cotacao = 1.0;

        return (quantidade * valorEstimado * cotacao);
      },
      classeCuidadoEspecial(valor) {
        return valor ? 'fa-check-square-o' : 'fa-square-o';
      }
    }
  }
</script>

<template>
  <div>
    <h3 class="m-t m-b">Elemento de Despesa</h3>
    <div class="hr-line-dashed margin-top-5"></div>

    <div class="row">
      <dl class="col-sm-2">
        <dt>
          <i class="fa" :class="classeOpcoes(item.despesaCapital)"></i> Despesa de Capital <br>
        </dt>
      </dl>

      <dl class="col-sm-2">
        <dt>
          <i class="fa" :class="classeOpcoes(item.materialConsumo)"></i> Material de Consumo <br>
        </dt>
      </dl>

      <dl class="col-sm-2">
        <dt>
          <i class="fa" :class="classeOpcoes(item.servico)"></i> Serviço <br>
        </dt>
      </dl>

      <dl class="col-sm-2">
        <dt>
          <i class="fa" :class="classeOpcoes(item.despesaEnvio)"></i> Despesas com Envio <br>
        </dt>
      </dl>
    </div>

    <div class="hr-line-dashed"></div>

    <div class="row">
        <dl v-if="item.despesaCapital">
            <dd>
                <div class="col-sm-2">
                    <i class="fa" :class="classeCuidadoEspecial(item.equipamentoComputador)"></i> Computador
                </div>

                <div class="col-sm-2">
                    <i class="fa" :class="classeCuidadoEspecial(item.equipamentoMedicaoControle)"></i> Medição e Controle
                </div>

                <div class="col-sm-2">
                    <i class="fa" :class="classeCuidadoEspecial(item.equipamentoHospitalar)"></i> Hospitalar
                </div>

                <div class="col-sm-2">
                    <i class="fa" :class="classeCuidadoEspecial(item.equipamentoMecanicoEletronico)"></i> Mecânico / Eletrônico
                </div>

                <div class="col-sm-2">
                    <i class="fa" :class="classeCuidadoEspecial(item.equipamentoOtico)"></i> Ótico
                </div>

                <div class="col-sm-2">
                    <i class="fa" :class="classeCuidadoEspecial(item.equipamentoOutros)"></i> Outros
                </div>
            </dd>
        </dl>

        <dl v-if="item.materialConsumo">
            <dd>
                <div class="col-sm-2">
                    <i class="fa" :class="classeCuidadoEspecial(item.bensConsumoQuimico)"></i> Químico
                </div>

                <div class="col-sm-2">
                    <i class="fa" :class="classeCuidadoEspecial(item.bensConsumoPerecivel)"></i> Perecível
                </div>

                <div class="col-sm-2">
                    <i class="fa" :class="classeCuidadoEspecial(item.bensConsumoEletronico)"></i> Eletrônico
                </div>

                <div class="col-sm-2">
                    <i class="fa" :class="classeCuidadoEspecial(item.bensConsumoPecasAcessorios)"></i> Peças e Acessórios
                </div>

                <div class="col-sm-2">
                    <i class="fa" :class="classeCuidadoEspecial(item.bensConsumoBiologico)"></i> Biológico
                </div>

                <div class="col-sm-2">
                    <i class="fa" :class="classeCuidadoEspecial(item.bensConsumoOutros)"></i> Outros <br>
                </div>
            </dd>
        </dl>

        <dl v-if="item.servico">
            <dd>
                <div class="col-sm-2">
                    <i class="fa" :class="classeCuidadoEspecial(item.servicoCongresso)"></i> Congresso
                </div>

                <div class="col-sm-2">
                    <i class="fa" :class="classeCuidadoEspecial(item.servicoAmostras)"></i> Amostras
                </div>

                <div class="col-sm-2">
                    <i class="fa" :class="classeCuidadoEspecial(item.servicoEdicaoTexto)"></i> Edição de Texto
                </div>

                <div class="col-sm-2">
                    <i class="fa" :class="classeCuidadoEspecial(item.servicoPublicacao)"></i> Publicação
                </div>

                <div class="col-sm-2">
                    <i class="fa" :class="classeCuidadoEspecial(item.servicoSoftware)"></i> Software
                </div>

                <div class="col-sm-2">
                    <i class="fa" :class="classeCuidadoEspecial(item.servicoOutros)"></i> Outros <br>
                </div>
            </dd>
        </dl>
    </div>

    <div class="hr-line-dashed"></div>

    <div class="row">
        <dl class="col-sm-6">
            <dt>Descrição do material/serviço em inglês</dt>
            <dd class="white-space-pre">{{ item.descricao }}</dd>
        </dl>

        <dl class="col-sm-6">
            <dt>Descrição do material/serviço - traduzida</dt>
            <dd class="white-space-pre">{{ item.descricaoTraduzida }}</dd>
        </dl>
    </div>

    <div class="row">
      <dl class="col-sm-2">
        <dt>Código do item</dt>
        <dd class="white-space-pre">{{ item.codigoItem || '---'  }}</dd>
      </dl>

      <dl class="col-sm-2">
        <dt>Quantidade</dt>
        <dd>{{ item.quantidade | fixar2digitos }}</dd>
      </dl>

      <dl class="col-xs-2" v-if="configuracao.utilizarValorEstimadoImportacao">
        <dt>Valor unitário {{retornaSimboloMoeda}}</dt>
        <dd>{{ item.valorEstimado | fixar2digitos }}</dd>
      </dl>

      <dl class="col-xs-2" v-if="configuracao.utilizarValorEstimadoImportacao">
        <dt>Valor total {{retornaSimboloMoeda}}</dt>
        <dd>{{ valorTotal(item) | formatarNumero }}</dd>
      </dl>

      <dl class="col-xs-2" v-if="configuracao.utilizarValorEstimadoImportacao">
        <dt>Cotação estimada</dt>
        <dd>{{ solicitacao.cotacaoEstimada ? solicitacao.cotacaoEstimada : '1,0000' }}</dd>
      </dl>

      <dl class="col-xs-2" v-if="configuracao.utilizarValorEstimadoImportacao">
        <dt>Valor total estimado (R$)</dt>
        <dd>{{ valorTotalReal(item) | formatarNumero }}</dd>
      </dl>
    </div>

    <div class="row">
      <dl class="col-sm-2">
        <dt>Unidade</dt>
        <dd>{{ item.unidade || '---' }}</dd>
      </dl>

      <dl class="col-sm-2">
        <dt>NCM ou HS CODE</dt>
        <dd>{{ item.ncmhsCode || '---' }}</dd>
      </dl>

      <dl class="col-sm-4">
        <dt>Nome fabricante</dt>
        <dd>{{ item.nomeFabricante || '---' }}</dd>
      </dl>

      <dl class="col-sm-4">
        <dt>País procedência</dt>
        <dd>{{ item.paisProcedencia || '---' }}</dd>
      </dl>
    </div>

    <div class="hr-line-dashed"></div>

    <dl>
      <dt>Observação do item de importação</dt>
      <dd class="white-space-pre">{{ item.observacaoItemImportacao || '---' }}</dd>
    </dl>

    <dl>
      <dt>Objetivo/Justificativa da importação</dt>
      <dd class="white-space-pre">{{ item.objetivoImportacao || '---' }}</dd>
    </dl>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-importacao-projeto/componentes/compartilhado/FormListaImportacao.vue